import { gql } from "gql";

export const GET_DYNAMIC_ENUMS_FOR_SELECT = gql(/* GraphQL */ `
  query GetDynamicEnumsForEnumSelect {
    findDynamicEnums {
      content {
        id
        name {
          value
        }
      }
    }
  }
`);
